export default __webpack_public_path__ + "static/media/ShiftsInprogress.b9b4cf35.svg";